<template>
  <div class="content--sinoreg ordemServico p-1">
    <h4 class="ordemServico_title">
      Ordens de Serviços
    </h4>

    <div class="row col-12 ml-0 pl-2 pr-0">
      <div class="col-sm-9 col-12">
        <OrdensServicoSearch @buscaManual="buscaOrdensDeServicos" />
      </div>

      <div class="col-sm-3 col-12 mt-4 pt-3 pr-3 text-right">
        <button class="btn btn-sm btn-primary"
                @click="$router.push({ name: 'ordem_servico_novo' })">
          <icon-svg icon="add"
                    class="icon--xs icons--white" />
          Adicionar Nova Ordem de Serviço
        </button>
      </div>
    </div>

    <div v-if="ordensDeServicos && ordensDeServicos.length">
      <div v-if="ordensDeServicos.length > 9"
           class="row col-12 ml-0 mr-3 mt-4 mb-3">
        <div class="col-sm-10 col-10 pl-0 pr-0 paginate d-inline-flex justify-content-center align-items-center">
          <p class="paginate_text small d-inline-block mt-0">
            Página
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': (Number(paginacao.page) === 1) }"
                  :disabled="(Number(paginacao.page) === 1)"
                  type="button"
                  title="Página anterior"
                  @click="paginaAnterior()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowLeft.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            <select v-model="paginacao.page"
                    class="form-control form-control-sm"
                    @change="selecionaPagina(paginacao.page)">
              <option v-for="(value, index) in paginacao.lastPage"
                      :key="`option_paginate_selos_gerenc_${ index }_${ _uid }`">
                {{ value }}
              </option>
            </select>
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': Number(paginacao.page) === paginacao.lastPage }"
                  :disabled="(Number(paginacao.page) === paginacao.lastPage)"
                  type="button"
                  title="Próxima página"
                  @click="proximaPagina()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowRight.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            {{ `de ${paginacao.lastPage}` }}
          </p>
        </div>
        <div class="botoesListaCard ml-3">
          <button class="btn btn-sm btn-primary btnListaCard"
                  @click="viewLista()">
            <icon-svg icon="listOs"
                      class="icon--xs icons--black" />
            Lista
          </button>
          <button class="btn btn-sm btn-primary btnListaCard"
                  @click="viewCard()">
            <icon-svg icon="cardOs"
                      class="icon--xs icons--black" />
            Card
          </button>
        </div>
      </div>

      <div class="ml-3 mr-3"
           :class="{ 'mt-4': ordensDeServicos.length <= 9 }">
        <OrdensServicoList :prop-ordens-servico="ordensDeServicos"
                           :prop-visualizacao="opcaoVisualizacao"
                           :pode-enviar-selos="podeEnviarSelos"
                           @onEdit="editarOS"
                           @onDelete="deletarOS"
                           @imprimirRecibo="imprimirReciboOS" 
                           @enviarSelo="enviarSeloManualmenteTJ" />
      </div>

      <div class="row col-12 ml-0 mr-3 mt-2 mb-3">
        <div class="col-sm-12 col-12 pl-0 pr-0 paginate d-inline-flex justify-content-center align-items-center">
          <p class="paginate_text small d-inline-block mt-0">
            Página
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': (Number(paginacao.page) === 1) }"
                  :disabled="(Number(paginacao.page) === 1)"
                  type="button"
                  title="Página anterior"
                  @click="paginaAnterior()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowLeft.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            <select v-model="paginacao.page"
                    class="form-control form-control-sm"
                    @change="selecionaPagina(paginacao.page)">
              <option v-for="(value, index) in paginacao.lastPage"
                      :key="`option_paginate_selos_gerenc_${ index }_${ _uid }`">
                {{ value }}
              </option>
            </select>
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': Number(paginacao.page) === paginacao.lastPage }"
                  :disabled="(Number(paginacao.page) === paginacao.lastPage)"
                  type="button"
                  title="Próxima página"
                  @click="proximaPagina()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowRight.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            {{ `de ${paginacao.lastPage}` }}
          </p>
        </div>
      </div>

      <ModalImpressao :url="urlRecibo"
                      @close="() => urlRecibo = ''" />
    </div>

    <div v-else>
      <label class="pt-3 pl-4">
        Nenhuma ordem de serviço cadastrada. Aguardando cadastro.
      </label>
    </div>
  </div>
</template>

<script>
  /* assets */
  import arrowLeft from '@/assets/icons/arrow-left.svg?sprite'
  import arrowRight from '@/assets/icons/arrow-right.svg?sprite'

  /* components */
  import OrdensServicoSearch from '@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoSearch'
  import OrdensServicoList from '@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoList'
  import ModalImpressao from '../../components/ModalImpressao/ModalImpressao'

  /* services */
  import RecibosService from '@/services/Registros/RecibosService'
  import OrdensServicoService from '@/services/Registros/OrdensServicoService'
  import CustasService from '@/services/Registros/CustasService'
  import SelosService from '@/services/Registros/SelosService'

  /* constants */
  import custas from '@/constants/custas'

  import Swal from 'sweetalert2'
  import moment from 'moment'
  import { mapGetters } from "vuex"

  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'

  export default {
    name: 'VisualizaOrdensDeServicos',
    components: {
      OrdensServicoSearch,
      OrdensServicoList,
      ModalImpressao
    },
    data () {
      return {
        // icons
        arrowLeft,
        arrowRight,

        // list os sem registro_id
        ordensDeServicos: [],
        opcaoVisualizacao: "",

        // controle de paginação
        paginacao: {
          page: 1,
          perPage: 15,
          lastPage: 1
        },

        urlRecibo: null,
        custas: [],

        osFiltradasPorStatusDosSelos: null,
        status_selos: null,
        armazenaDadosDoPayload: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj',
        cartorioId: 'auth/getCartorioId',
        exibirSelosNaoEnviados: 'statusDosSelos/getSelosNaoEnviados',
        contagemDeExibicaoDosSelosNaoEnviados: 'statusDosSelos/getContagemDeExibicaoDosSelosNaoEnviados',
        contagemDeExibicaoDeTodosOsSelos: 'statusDosSelos/getContagemDeExibicaoDeTodosOsSelos'
      })
    },
    watch: {
      contagemDeExibicaoDosSelosNaoEnviados () {
        let payload = this.criandoPayload('contagemDeExibicaoDosSelosNaoEnviados')
        this.buscaOrdensDeServicos(payload)
      },
      contagemDeExibicaoDeTodosOsSelos () {
        let payload = this.criandoPayload('contagemDeExibicaoDeTodosOsSelos')
        this.buscaOrdensDeServicos(payload)
      },
    },
    beforeMount () {
      this.buscaOrdensDeServicos()
    },
    methods: {
      viewCard () {
        this.opcaoVisualizacao = "card"
      },
      viewLista () {
        this.opcaoVisualizacao = "lista"
      },
      async buscaOrdensDeServicos (filtro = null) {
        try {
          loader({ text: 'Aguarde...', active: true })

          let payload = {
            page: this.paginacao.page,
            perPage: this.paginacao.perPage
          }

          if (filtro) {
            if (filtro.status_selos !== this.status_selos) {
              this.status_selos = filtro.status_selos
              this.paginacao.page = 1
              this.paginacao.perPage = 15
            }

            payload = {
              ...payload,
              identificadorSolicitante: filtro.identificadorSolicitante || null,
              data_cumprida: filtro.data_cumprida || null,
              status_selos: filtro.status_selos || null,
            }
            this.armazenaDadosDoPayload = payload
          }

          if (this.exibirSelosNaoEnviados && !this.status_selos) {
            payload.status_selos = 'selos_nao_enviados'
          } else if (!this.exibirSelosNaoEnviados && !this.status_selos) {
            payload.status_selos = null
          } else if (this.status_selos) {
            payload = {
              page: this.paginacao.page,
              perPage: this.paginacao.perPage,
              status_selos: this.status_selos,
              identificadorSolicitante: this.armazenaDadosDoPayload.identificadorSolicitante,
              data_cumprida: this.armazenaDadosDoPayload.data_cumprida,
            }
          }

          const { data, lastPage } = await OrdensServicoService.getOS(payload)
          this.ordensDeServicos = data
          this.paginacao.lastPage = lastPage

          this.getCustas()

          loader({ text: '', active: false })
        } catch (error) {
          loader({ text: '', active: false })

          displayMessage('error', '', `Não foi possível obter as ordens de serviços com "${this.statusSelosNaMensagemDeErro(this.status_selos)}". Tente novamente.`)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      },
      paginaAnterior () {
        this.paginacao.page = Number(this.paginacao.page) - 1

        return this.buscaOrdensDeServicos()
      },
      selecionaPagina (page = 1) {
        this.paginacao.page = Number(page)

        return this.buscaOrdensDeServicos()
      },
      proximaPagina () {
        this.paginacao.page = Number(this.paginacao.page) + 1
        return this.buscaOrdensDeServicos()
      },
      editarOS (ordemDeServico) {
        if (!ordemDeServico || !ordemDeServico.os) return

        this.$router.push({ name: 'ordem_servico_editar', params: { id: ordemDeServico.os.ordem_servico_id } })
      },
      deletarOS (ordemDeServico) {
        if (!ordemDeServico || !ordemDeServico.os) return

        const selos = this.verifySelos(ordemDeServico.os)

        if (selos > 0) {
          displayMessage('question', 'Atenção!', 'Esta OS possui selos. Para excluir a OS, verifique os itens dentro dela.',{cancelButtonText: 'Voltar', confirmButtonText: 'Visualizar OS'}).then(status => {
            if (status.value) {
              // Direcionando para a Ordem de Serviço
              this.editarOS(ordemDeServico)
            }
          })
          return

        } else {
          displayMessage('question', 'Tem certeza que deseja excluir essa ordem de serviço?', '',{cancelButtonText: 'Não', confirmButtonText: 'Sim'}).then(async (res) => {
            if (res.value) {
              ordemDeServico.os = {
                ...ordemDeServico.os,
                cancelada: true,
                data_cancelamento: moment().format('YYYY-MM-DD')
              }

              try {
                loader({ text: 'Aguarde...', active: true })

                const payload = ordemDeServico.os

                // Verificamos se a OS tem algum selo
                payload.existeSelo = !!payload.itens.find(item => item.seloItemOs.length)

                await OrdensServicoService.updateOS(payload, payload.ordem_servico_id)

                loader({ text: '', active: false })

                this.buscaOrdensDeServicos()
              } catch (e) {
                loader({ text: '', active: false })

                displayMessage('error', 'Erro!', e.response.data.message || 'Não foi possível excluir essa ordem de serviço. Tente novamente.' )

                setTimeout(() => {
                  const btnCancel = document.querySelector('.swal2-cancel')

                  if (btnCancel) btnCancel.focus()
                }, 200)
              }
            }
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-cancel')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        }
      },
      async imprimirReciboOS (ordemDeServico) {
        if (!ordemDeServico) return

        const itensInvalidos = ordemDeServico.itens.filter(item => item.flag_cancelado)

        if (itensInvalidos.length > 0) {
          displayMessage('error', '', 'Os itens da ordem de serviço não são válidos para o recibo.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)

          return
        }

        const payload = {
          os: ordemDeServico,
          cartorio: this.cartorioObj,
          custas: ordemDeServico.itens,
          emolumentos: this.getEmolumentos(ordemDeServico.itens)
        }

        try {
          loader({ text: 'Aguarde...', active: true })

          this.urlRecibo = await RecibosService.reciboSemRegistro(payload)

          loader({ text: '', active: false })
        } catch (e) {
          loader({ text: '', active: false })

          displayMessage('error', '', 'Não foi possível imprimir o recibo da ordem de serviço. Tente novamente.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      },
      async enviarSeloManualmenteTJ (ordemDeServico) {
        try {
          const questionText = 'Confirmar o envio manual dos selos da OS ' + ordemDeServico.numero + '?'
          const response = await displayQuestion(null, questionText, 'Sim', 'Não', null, '#074f7f', '#8b0000')

          if (!response) return

          // Extrai os selos
          let selos = (ordemDeServico.itens || [])
            .flatMap(item => item.seloItemOs || [])
            .map(item => item.selo)
            .filter(selo => selo && selo.envio_tj === 0)

          let enviados = 0
          let falhas = 0
          let resultados = []

          // Envio individual
          for (let i = 0; i < selos.length; i++) {
            let selo = selos[i]

            try {
              await SelosService.enviarNumeroSeloApi(selo.num_selo)

              enviados++

              resultados.push({
                selo: selo.num_selo,
                status: 'sucesso'
              })
            } catch (error) {
              falhas++

              let mensagemErro = 'Erro ao enviar selo'

              if (error && error.response && error.response.data && error.response.data.mensagem) {
                mensagemErro = error.response.data.mensagem
              } else if (error && error.response && error.response.data && error.response.data.error) {
                mensagemErro = error.response.data.error
              } else if (error && error.message) {
                mensagemErro = error.message
              }

              resultados.push({
                selo: selo.num_selo,
                status: 'erro',
                erro: mensagemErro
              })
            }
          }

          // Todos os selos já enviados
          if (enviados === 0 && falhas === 0) {
            displayMessage('success', null, 'Todos os selos já foram enviados ao TJ.', { confirmButtonText: 'Continuar' })

            this.buscaOrdensDeServicos()
            return
          }

          // Sucesso total
          if (falhas === 0) {
            displayMessage('success', null, 'Selos enviados com sucesso!', { confirmButtonText: 'Continuar' })

            this.buscaOrdensDeServicos()
            return
          }

          // Erro parcial
          let mensagens = resultados
            .filter(item => item.status === 'erro')
            .map(item => '• Selo ' + item.selo + ': ' + item.erro)
            .join('<br>')

          displayMessage('success', null, mensagens, {useHtml: true, confirmButtonText: 'Continuar'})
          this.buscaOrdensDeServicos()

        } catch (error) {
          let mensagem = 'Ocorreu um erro ao enviar os selos para o TJ.'

          if (error && error.response && error.response.data && error.response.data.mensagem) {
            mensagem = error.response.data.mensagem
          } else if (error && error.response && error.response.data && error.response.data.message) {
            mensagem = error.response.data.message
          } else if (error && error.message) {
            mensagem = error.message
          }

          displayMessage('error', null, mensagem)
        }
      },
      podeEnviarSelos (ordemDeServico) {
        const selos = (ordemDeServico.itens || [])
          .flatMap(item => item.seloItemOs || [])
          .map(seloItem => seloItem.selo)
          .filter(Boolean)

        if (selos.length === 0) {
          return false
        }

        return selos.some(selo => selo.envio_tj === 0)
      },
      getEmolumentos (itensOS = []) {
        let emolumentos = []
        let valor = null

        itensOS.forEach(item => {
          const { custa, averbacao, quantidade } = item

          custa.itens.forEach(custaItem => {
            const emolumentoIndex = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)

            if (averbacao > 0) {
              const custaAverbacaoItem = this.custas.find(custaIss => custaIss.codigo === 12)
              const destinatario = custaAverbacaoItem.itens.filter(custa => custa.destino == custaItem.destino)
              valor = (custaItem.valor * quantidade) + (destinatario[0].valor * averbacao)
            } else {
              valor = (custaItem.valor * quantidade)
            }

            if (emolumentoIndex >= 0) {
              emolumentos[emolumentoIndex].valor += item.valor > 0 ? valor : 0
            } else {
              emolumentos.push({
                destino: custaItem.destino,
                valor: item.valor > 0 ? valor : 0
              })
            }
          })
        })

        emolumentos.push({
          destino: 'total',
          valor: emolumentos.map((e) => e.valor).reduce((a, b) => a + b, 0)
        })

        return emolumentos
      },
      imprimir () {
        window.open(this.urlRecibo)
      },
      verifySelos (os) {
        let selosQtd = 0

        os.itens.forEach(ordemServico => {
          if (ordemServico.seloItemOs && ordemServico.seloItemOs.length > 0 && !ordemServico.flag_cancelado) {
            ordemServico.seloItemOs.forEach(selo => {
              if (!!selo) {
                selosQtd++
              }
            })
          }
        })

        return selosQtd
      },
      async getCustas () {
        const { data } = await CustasService.getCustas({
          cartorio_id: this.cartorioId,
          uf: 'SP',
          perPage: 100,
          tipo: 'REGISTRO_CIVIL',
          os: 1,
          ativo: true
        })

        this.custas = data
      },
      criandoPayload (value) {
        let payload
        switch (value) {
        case 'contagemDeExibicaoDosSelosNaoEnviados':
          return payload = {
            status_selos: 'selos_nao_enviados',
          }
        case 'contagemDeExibicaoDeTodosOsSelos':
          return payload = {
            page: 1,
            perPage: 15,
          }
        }
      },
      statusSelosNaMensagemDeErro (status) {
        switch (status) {
        case 'selos_nao_enviados':
          return 'selos não enviados'
        case 'selos_enviados':
          return 'selos enviados'
        case 'PENDENTE':
          return 'selos pendentes'
        default:
          return 'todos'
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_utilities/_exports";

  .botoesListaCard .btn {
    background-color: #C6C6C6;
    border-color: #C6C6C6;
    padding-left: 1em;
    margin-left: 1em;
    opacity: 1;
    color: black;
    text-align: center;
  }

  .ordemServico {
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }

  .paginate {
    &_padding_label_pagina {
      padding-left: 20.5%
    }

    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_text_default {
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .Recibo {
    @media only screen and (max-width: 1600px) {
      &_modal {
        height: 33em !important;
        overflow: auto !important;
      }
    }

    @media only screen and (min-width: 1650px) {
      &_modal {
        height: 40em !important;
        overflow: auto !important;
      }
    }

  }

</style>
